import RestService from '../services/rest';

// GET
async function getDailyLoads(tableParams) {
  return RestService.postAuthenticated('dailyLoads/list/all', tableParams);
}

async function getDailyLoadDashboardData(tableParams) {
  return RestService.postAuthenticated('dailyLoads/getDailyLoadDashboardData', tableParams);
}

async function getDailyLoad(dailyLoadId) {
  return RestService.getAuthenticated('dailyLoads/detail', { dailyLoadId });
}

// POST
async function createDailyLoad(dailyLoad) {
  return RestService.postAuthenticated('dailyLoads/create', dailyLoad);
}

async function deleteDailyLoad(dailyLoadId) {
  return RestService.postAuthenticated('dailyLoads/delete', { dailyLoadId });
}

// PUT
async function updateDailyLoad(dailyLoad) {
  return RestService.putAuthenticated('dailyLoads/update', dailyLoad);
}

export default {
  getDailyLoads,
  getDailyLoad,
  createDailyLoad,
  updateDailyLoad,
  deleteDailyLoad,
  getDailyLoadDashboardData,
};
